import { render, staticRenderFns } from "./accBillDetail.vue?vue&type=template&id=390ca978&scoped=true"
import script from "./accBillDetail.vue?vue&type=script&lang=js"
export * from "./accBillDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./accBillDetail.vue?vue&type=style&index=1&id=390ca978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390ca978",
  null
  
)

export default component.exports